<template>
  <div direction="right" class="default-slider space-top-lg">
    <div class="slider-inner space-top-lg" style="width:55%; z-index: 9;" v-if="!isMetaDataEmpty">
      <div class="slider-header">
        <span>
          {{ selectedEntity.sub_entity_id}} -  {{ selectedEntity.entity_id}}
        </span>
        <div v-if="showRetrigger">
        <Button
            :key="selectedEntity.log_object_id"
            type="secondary"
            class="btn"
            @click.once="retrigger()"
            >{{$t('COURIER_RETRIGGER')}}</Button>
        </div>
      </div>
      <div class="slider-body p-0">
        <ElTabs class="tab-default tab-sm tab-bg no-bg">
          <Tab-pane :label="$t('INTEGRATION_DETAILS')">
            <div class="tab-content">
                <div class="flex-container panel-head align-top mb-0">
                  <div v-for="(item, index) in courierDetailsList" :key="`courier-list-${index}`">
                      <div v-for="(option, index) in item" :key="`courier-item-${index}`" class="ml-10">
                      <div v-if="option.dataType === 'date' && selectedEntity[option.value]">
                        <p v-if="selectedEntity[option.value]" >
                        {{ $t(option.tlabel) }} :
                        <strong>{{$moment(selectedEntity[option.value]).format("DD-MMM-YYYY")}}
                        </strong>
                        </p>
                      </div>
                      <div v-if="option.dataType === 'string' && selectedEntity[option.value]">
                        <p v-if="selectedEntity[option.value]" >
                        {{ $t(option.tlabel) }} : <strong>{{ (option.customData && transporterMap) ?
                          transporterMap[selectedEntity[option.value]] : selectedEntity[option.value] }}
                        </strong>
                        </p>
                      </div>
                  </div>
                </div>
                </div>
            </div>

          </Tab-pane>
        </ElTabs>
      </div>
    </div>
  </div>
</template>
<script>
import { courierDetailsList } from '@/constants/integrations';
import { mapGetters } from 'vuex';

export default {
  name: 'entityDetails',
  props: {
    selectedEntity: {
      type: Object,
    },
    columnName: {
      type: String,
    },
  },
  data() {
    return {
      courierDetailsList,
    };
  },
  computed: {
    ...mapGetters({
      transporters: 'order/getCourierTransporters',
    }),
    isMetaDataEmpty() {
      if (this.selectedEntity && this.selectedEntity.api_name) return false;
      return true;
    },
    showRetrigger() {
      return !this.selectedEntity.erp_retry_requested && this.selectedEntity.api_name === 'LR_BOOKING'
      && this.selectedEntity.mitm_error_status >= 400;
    },
    transporterMap() {
      return this.transporters.reduce((acc, curr) => {
        acc[curr.id] = curr.vname || curr.name;
        return acc;
      }, {});
    },
  },
  methods: {
    async getPayload() {
      let result = '';
      if (this.selectedEntity) {
        const tmsTransactionId = this.selectedEntity.tms_transaction_id;
        result = await this.$store.dispatch('order/getMitmPayload', { tmsTransactionId });
      }
      if (result && result.error) {
        this.$errorMessage({ message: result.error });
      }
    },
    async retrigger() {
      if (this.selectedEntity) {
        const data = {
          entity_id: this.selectedEntity.entity_id,
          api_name: this.selectedEntity.api_name,
          log_object_id: this.selectedEntity.log_object_id,
        };
        const result = await this.$store.dispatch('order/retryRequest', { data });
        if (result.status === 204) {
          this.$successMessage({ message: 'Retriggered successfully. Please check after sometime' });
        } else {
          this.$errorMessage({ message: result.error || 'Retrigger failed. Please try again later' });
        }
      }
    },
  },
};
</script>
<style scoped>
.default-slider .slider-inner.space-top-lg{
  top:248px !important;
}
</style>
